import styled, { css } from 'styled-components';

import { SHOP_CHIP_STATUS } from '@types';

export const Wrapper = styled.div<{ $state: SHOP_CHIP_STATUS }>`
	padding: 6px 8px;
	border-radius: 16px;
	text-transform: uppercase;
	font-size: 11px;
	line-height: 15px;
	font-weight: 600;

	${({ $state }) =>
		$state === SHOP_CHIP_STATUS.NEW &&
		css`
			background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkGreen};
			color: ${({ theme }) => theme.colors.other.calendarTextGreen};
		`}
	${({ $state }) =>
		$state === SHOP_CHIP_STATUS.HOT &&
		css`
			background-color: ${({ theme }) => theme.colors.other.calendarBackgroundDarkYellow};
			color: ${({ theme }) => theme.colors.other.calendarTextYellow};
		`}
`;
